import { RouteItem } from '@eastcoal/router/types/route'

import { ABNORMAL_RECORD_PAGE_UUID } from './constants/uuid'

export const abnormalBidRecordRoute: RouteItem = {
  title: '异常出价记录',
  uuid: ABNORMAL_RECORD_PAGE_UUID,
  path: '/abnormalBidRecord',
  Component: () => import('./index')
}
